import {Component} from "@angular/core";

@Component({
    selector: "fui-list-section",
    styleUrls: ["./list-section.component.scss"],
    templateUrl: "./list-section.component.html",
    standalone: false
})
export class FUIListSectionComponent {
}
